import { Method, RequestResult } from "domain/entities/method";
import { MethodRepository } from "domain/repositories";

export default class CreateUseCase {
    private methodRepository: MethodRepository;
    
    public constructor(methodRepository: MethodRepository) {
        this.methodRepository = methodRepository
    }

    public async createMethod(method: Method, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.methodRepository.createMethod(method, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}